import { ActionOverrideItemDisplayNamePayload, changeCurrentView } from "actions/collections";
import { mapSetOperation } from "actions/mutate";
import { COLLECTIONS } from "constants/action-types";
import { ISchemaKey, syncGridToSchema } from "helpers/product-collection";
import { List, Map } from "immutable";
import { ActionsObservable } from "redux-observable";

export const BACKEND_EXPECTED_OPERATION = "set_item_display_property_display_name_override";
export const ITEM_DISPLAY_PROPERTY_KEY = "item_display_property";
export const overrideItemDisplayNameEpic = (action$: ActionsObservable<any>, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.ITEM_DISPLAY_PROPERTY.OVERRIDE_DISPLAY_NAME.MUTATE)
        .map(({ payload }) => payload)
        .switchMap(({ fieldName, newDisplayName }: ActionOverrideItemDisplayNamePayload) => {
            const {
                mutate: { snapshots },
                collection: { collectionId, columnApi },
            } = store.getState();

            const itemDisplayPropertyMap: Map<keyof ISchemaKey, any> = snapshots.getIn([
                collectionId,
                "item_display_property",
            ]);

            const itemsList: List<Map<string, any>> = itemDisplayPropertyMap.getIn(["struct_value", "keys"]);

            const indexToUpdate = itemsList.findIndex((item) => item.get("field_name") === fieldName);

            const updatedList = itemsList.update(indexToUpdate, (item) =>
                item.set("display_name_override", newDisplayName)
            );
            const syncedSchema = syncGridToSchema(updatedList, columnApi);

            return [
                mapSetOperation(
                    collectionId,
                    ITEM_DISPLAY_PROPERTY_KEY,
                    itemDisplayPropertyMap.setIn(["struct_value", "keys"], updatedList)
                ),
                changeCurrentView({ data: syncedSchema }),
            ];
        });
